import { IMAGE_MODELS, VIDEO_MODELS, type ModelConfig } from '../lib/models'
import useLoraModels from '../hooks/useLoraModels'

interface ModelSelectorProps {
  selectedModelId: string
  onChange: (modelId: string) => void
}

function ModelGroup({
  label,
  models,
  selectedModelId,
  onChange,
}: {
  label: string
  models: ModelConfig[]
  selectedModelId: string
  onChange: (modelId: string) => void
}) {
  return (
    <div className="space-y-1.5">
      <h4 className="text-xs font-semibold uppercase tracking-wider text-text-muted px-2">
        {label}
      </h4>
      {models.map((model) => {
        const isSelected = model.id === selectedModelId
        return (
          <button
            key={model.id}
            onClick={() => onChange(model.id)}
            className={`w-full text-left px-3 py-2.5 rounded-lg transition-all cursor-pointer ${
              isSelected
                ? 'border border-neon bg-neon/5 neon-glow'
                : 'border border-transparent hover:bg-bg-elevated hover:border-border-hover'
            }`}
          >
            <div className="flex items-center justify-between">
              <span
                className={`text-sm font-medium ${
                  isSelected ? 'text-neon' : 'text-text-primary'
                }`}
              >
                {model.name}
              </span>
              <span className="text-xs px-1.5 py-0.5 rounded bg-bg-elevated text-text-muted">
                {model.speed}
              </span>
            </div>
            <p className="text-xs text-text-muted mt-0.5">{model.description}</p>
          </button>
        )
      })}
    </div>
  )
}

export default function ModelSelector({
  selectedModelId,
  onChange,
}: ModelSelectorProps) {
  const loras = useLoraModels()
  return (
    <div className="space-y-4">
      <ModelGroup
        label="Image Models"
        models={IMAGE_MODELS}
        selectedModelId={selectedModelId}
        onChange={onChange}
      />
      {loras.length > 0 && (
        <ModelGroup
          label="Your LoRAs"
          models={loras}
          selectedModelId={selectedModelId}
          onChange={onChange}
        />
      )}
      <ModelGroup
        label="Video Models"
        models={VIDEO_MODELS}
        selectedModelId={selectedModelId}
        onChange={onChange}
      />
    </div>
  )
}
